import React from "react"
import { useSiteMetadata } from "../hooks/useSiteMetadata";

export const Seo = ({ title, description, pathname, children }) => {
  const { title: defaultTitle, description: defaultDescription, siteUrl } = useSiteMetadata();
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    url: `${siteUrl}${pathname || ``}`,
  };
  return (
    <>
      <title>{seo.title}</title>
      <link rel="icon" type="image/png" href='/favicon.png'></link>
      <meta name="description" content={seo.description} />
      <script async src="https://www.google.com/recaptcha/api.js?render=6Lc-p1MmAAAAADU_6MWLucA8485bN6c46uzV24NG"></script>
      {children}
    </>
  );
};
